module.exports = __webpack_public_path__ + "media/images/pic/teachers/kaede-funakoshi-af80a631fce7a3b4034754989f13418a.webp";